<script setup lang="ts">
import type { TabContentProps } from "./tab.types";
import { useTabContent } from "./useTabContent";

const props = defineProps<TabContentProps>();

const { classes, isActive } = useTabContent({ props });
</script>

<template>
  <!--
    v-show keeps the slot in shadow DOM at all times so slot projection
    continues regardless of active state (CE constraint — never v-if on
    a wrapper that contains a slot driven by business logic).
  -->
  <div
    v-show="isActive"
    part="base"
    :class="classes"
    class="e-tab-content"
    role="tabpanel"
    :aria-labelledby="`tab-trigger-${props.value}`"
    :data-active="isActive"
  >
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
